import { useFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/form/use-form-validation';
import { RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export interface ResetPasswordOtpStepForm {
  code: string;
}

export const useResetPasswordOtpStepFormValidation = (): {
  code: RegisterOptions<ResetPasswordOtpStepForm, 'code'>;
} => {
  const { t } = useTranslation();
  const formValidationRules = useFormValidation();

  return {
    code: {
      ...formValidationRules.required({
        field: t('$.login.reset-password.otp'),
      }),
      ...formValidationRules.otpPattern({
        field: t('$.login.reset-password.otp'),
      }),
    },
  };
};
